import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import update603324 from './update'
/**
* @see \App\Http\Controllers\EmailController::update
 * @see app/Http/Controllers/EmailController.php:62
 * @route '/account/email/update'
 */
export const update = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(options),
    method: 'post',
})

update.definition = {
    methods: ["post"],
    url: '/account/email/update',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\EmailController::update
 * @see app/Http/Controllers/EmailController.php:62
 * @route '/account/email/update'
 */
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\EmailController::update
 * @see app/Http/Controllers/EmailController.php:62
 * @route '/account/email/update'
 */
update.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\EmailController::update
 * @see app/Http/Controllers/EmailController.php:62
 * @route '/account/email/update'
 */
    const updateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: update.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\EmailController::update
 * @see app/Http/Controllers/EmailController.php:62
 * @route '/account/email/update'
 */
        updateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: update.url(options),
            method: 'post',
        })
    
    update.form = updateForm
const email = {
    update: Object.assign(update, update603324),
}

export default email